import posthog from "posthog-js";

/**
 * Track a custom event in PostHog.
 * Safe to call in any environment - no-ops if PostHog isn't loaded.
 */
export function trackEvent(
  eventName: string,
  properties?: Record<string, unknown>,
) {
  if (typeof posthog !== "undefined" && posthog.__loaded) {
    posthog.capture(eventName, properties);
  }
}
